module.exports = __webpack_public_path__ + "static/media/lamp.516c21bc.jpg";